import flatpickr from "flatpickr";
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Spanish } from "flatpickr/dist/l10n/es.js";

export function flatpickrCustomizado(selector, config, culture = "pt-br") {

    // Configuração base (PT-BR como exemplo)
    let defaultConfig = {
        disableMobile: true,
        locale: Portuguese,
        altFormat: "d/m/Y", 
        dateFormat: "Y-m-d",
        allowInput: true,
        altInput: true,
        time_24hr: true
    };


    switch (culture?.toLowerCase()) {
        case "pt-br":
            defaultConfig.locale = Portuguese;      // Localização PT-BR
            defaultConfig.altFormat = "d/m/Y";      // Exemplo: 06/01/2025
            defaultConfig.dateFormat = "Y-m-d";     // Valor real do input
            defaultConfig.time_24hr = true;         // 24 horas
            break;

        case "en-us":
            // Se não setar locale, fica no inglês padrão do flatpickr
            // Ou caso queira forçar, poderia usar `defaultConfig.locale = English;`
            defaultConfig.locale = null;
            // Para data no formato US
            defaultConfig.altFormat = "m/d/Y";      // Exemplo: 01/06/2025
            defaultConfig.dateFormat = "Y-m-d";
            
            // Se quiser usar formatação de 12h com AM/PM:
            // defaultConfig.time_24hr = false;    // -> hh:mm AM/PM
            // Exemplo se quiser exibir no input de "hora" com AM/PM:
            // defaultConfig.altFormat = "m/d/Y h:i K"; 
            
            // Caso queira 24h:
            // defaultConfig.time_24hr = true;
            break;

        case "es-cl":
            defaultConfig.locale = Spanish;         // Localização ES
            defaultConfig.altFormat = "d-m-Y";      // Exemplo: 06-01-2025
            defaultConfig.dateFormat = "Y-m-d";
            defaultConfig.time_24hr = true;         // 24 horas
            break;

        default:
            // Se não vier nada ou vier algo fora das opções,
            // você pode manter o pt-BR como padrão, ou escolher outro default
            defaultConfig.locale = Portuguese;
            defaultConfig.altFormat = "d/m/Y";
            defaultConfig.dateFormat = "Y-m-d";
            defaultConfig.time_24hr = true;
            break;
    }

     if(config['enableTime']){
        defaultConfig.time_24hr = true;
        defaultConfig.dateFormat = "Y-m-d H:i";
        defaultConfig.altFormat = "d/m/Y H:i";
    }

    // Mescla as configurações padrões com as configurações específicas passadas
    const finalConfig = { ...defaultConfig, ...config };

    return flatpickr(selector, finalConfig);
}
